import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

import {materialTitle} from "../../material/shared/data.service";

@Component({
    selector: 'app-material-servico-table',
    template: require('./material-servico-table.component.html')
})

export class MaterialServicoTableComponent implements OnInit {
    @Input() list: any[];
    @Input() showDelete: boolean = false;
    @Output() deleteEvent: EventEmitter<any> = new EventEmitter();

    materialTitle: any = materialTitle;

    constructor(
    ){}

    ngOnInit() {

    }

    clickRemove(item: any, index: number) {
        this.deleteEvent.next([item, index]);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-servico/material-servico-table/material-servico-table.component.ts
 **/